(() => {
  if (customElements.get('collection-sort')) {
    return;
  }

  class CollectionSort extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.select = this.querySelector('select');
      if (this.select) {
        this.select.addEventListener(
          'change',
          this.handleSelectChange.bind(this),
        );
      }

      this.buttons = this.querySelectorAll('[data-option]');
      this.buttons.forEach((button) => {
        button.addEventListener('click', this.handleButtonClick.bind(this));
      });
    }

    replaceCollectionHTML(html) {
      const collections = document.querySelectorAll('.collection');
      if (!collections.length) {
        return;
      }
      collections.forEach((collection) => {
        const collectionID = collection.getAttribute('id');
        const newCollection = html.querySelector(`#${collectionID}`);
        if (!newCollection) {
          console.warn(
            'Could not find new collection HTML for ID:',
            collectionID,
          );
          return;
        }
        collection.innerHTML = newCollection.innerHTML;
      });
    }

    handleButtonClick(event) {
      const target = event.currentTarget;
      const selectedValue = target.getAttribute('data-value');
      this.select.value = selectedValue;
      this.select.dispatchEvent(new Event('change', { bubbles: true }));

      this.querySelector('[data-selected-option]').innerHTML =
        target.getAttribute('data-label');
    }

    handleSelectChange(event) {
      const selectedValue = event.target.value;

      this.buttons.forEach((button) => {
        button.classList.toggle(
          'is-selected',
          button.getAttribute('data-value') === selectedValue,
        );
      });

      this.querySelector('details')?.removeAttribute('open');

      const url = new URL(window.location.href);
      url.searchParams.set('sort_products', selectedValue);
      window.history.pushState({}, '', url);

      fetch(url.toString())
        .then((response) => response.text())
        .then((res) => {
          const parser = new DOMParser();
          const html = parser.parseFromString(res, 'text/html');
          this.replaceCollectionHTML(html);
        })
        .catch((error) => {
          console.error('Error fetching sorted products:', error);
        });
    }
  }

  customElements.define('collection-sort', CollectionSort);
})();
